import { FormControl } from '@angular/forms';
import { environment } from '@env/environment';
import * as WAValidator from 'wallet-address-validator';
import { CurrencyType } from '@app/core/balance.service';

export const validateWallet = (currency: string | CurrencyType) => (c: FormControl) => {
  let _currency = currency.toString().toLowerCase();
  if (['edg', 'usdt20', 'dai'].includes(_currency)) {
    _currency = 'eth';
  }
  let valid = false;
  try {
    valid = WAValidator.validate(c.value, _currency, environment.production ? 'prod' : 'both');
  } catch (e) {}
  return valid
    ? null
    : {
        validateWallet: {
          valid: false,
        },
      };
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/validators/wallet.validator.ts